import { useCallback } from 'react';

import { useDeleteUserCauseSelection } from 'core/Api';
import { ClickableOptionsCard } from 'core/Components';
import { getErrorMessage_v2 } from 'core/Utils';
import { RemoveFromMyCausesModal, ThemeIcon, notifications } from 'ui';
import { IconBookmarkHeart } from 'ui/Icons';

import { ManageMyCausesModal } from './ManageMyCausesModal';
import {
  ManageMyCausesModalProvider,
  useManageMyCausesModalProvider,
} from './ManageMyCausesProvider';

const RemoveCauseModalWrapper = () => {
  const { opened, meta, openPreviousStep } = useManageMyCausesModalProvider({ id: 'RemoveCause' });

  const { mutate: deleteCauseSelection } = useDeleteUserCauseSelection();
  const handleRemoveFromMyCauses = useCallback(() => {
    if (meta?.cause?.uuid) {
      deleteCauseSelection(
        { causeId: meta?.cause?.uuid },
        {
          onSuccess: () => {
            notifications.show({ message: 'Your cause has been removed', variant: 'success' });
            openPreviousStep();
          },
          onError: (error) =>
            notifications.show({ message: getErrorMessage_v2(error), variant: 'error' }),
        }
      );
    }
  }, [meta?.cause?.uuid, openPreviousStep, deleteCauseSelection]);

  return (
    <RemoveFromMyCausesModal
      opened={opened}
      onClose={() => openPreviousStep()}
      onRemoveFromMyCauses={handleRemoveFromMyCauses}
      causeName={meta?.cause?.name}
      causeImg={meta?.cause?.logo?.url}
    />
  );
};

const ManageMyCausesAction = () => {
  const { openModalById } = useManageMyCausesModalProvider({});

  return (
    <ClickableOptionsCard.Row
      leftSection={
        <ThemeIcon variant="transparent" c="gray.2">
          <IconBookmarkHeart />
        </ThemeIcon>
      }
      title="Manage My Causes"
      onClick={() => openModalById('ManageCauses')}
    />
  );
};

const ManageMyCausesGroup = () => {
  return (
    // eslint-disable-next-line react/jsx-no-undef
    <ManageMyCausesModalProvider meta={{}}>
      <ManageMyCausesAction />
      <ManageMyCausesModal />
      <RemoveCauseModalWrapper />
    </ManageMyCausesModalProvider>
  );
};

export { ManageMyCausesGroup };
